import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import RichTextEditor from "@/components/admin/RichTextEditor";
import { Save } from "lucide-react";

const PAGES = [
  { slug: "home", label: "Ana Sayfa", plain: true },
  { slug: "premium", label: "Premium Sayfası" },
  { slug: "privacy", label: "Gizlilik Politikası" },
  { slug: "terms", label: "Kullanım Koşulları" },
];

export default function PagesTab() {
  const [active, setActive] = useState("home");
  const [page, setPage] = useState({ title: "", body: "" });
  const [saving, setSaving] = useState(false);
  const current = PAGES.find((p) => p.slug === active);

  const load = (slug) => {
    api.get(`/pages/${slug}`).then(({ data }) => setPage({ title: data.title, body: data.body })).catch(() => {});
  };
  useEffect(() => {
    load(active);
  }, [active]);

  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/admin/pages/${active}`, page);
      toast.success("Sayfa güncellendi.");
    } catch {
      toast.error("Kaydedilemedi.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap gap-2">
        {PAGES.map((p) => (
          <button
            key={p.slug}
            onClick={() => setActive(p.slug)}
            data-testid={`page-tab-${p.slug}`}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
              active === p.slug ? "bg-[#0F2F1D] text-white" : "bg-[#F8F9FA] text-[#5C6F62] hover:bg-[#E2E8E4]"
            }`}
          >
            {p.label}
          </button>
        ))}
      </div>

      <div className="max-w-3xl space-y-5">
        <label className="block">
          <span className="block text-sm font-medium text-[#1A251E] mb-2">Başlık</span>
          <input value={page.title} onChange={(e) => setPage({ ...page, title: e.target.value })} data-testid="page-title-input" className="sr-input" />
        </label>

        <div>
          <span className="block text-sm font-medium text-[#1A251E] mb-2">{current?.plain ? "Açıklama Metni" : "İçerik"}</span>
          {current?.plain ? (
            <textarea rows={4} value={page.body} onChange={(e) => setPage({ ...page, body: e.target.value })} data-testid="page-body-input" className="sr-input resize-none" />
          ) : (
            <RichTextEditor key={active} value={page.body} onChange={(body) => setPage((p) => ({ ...p, body }))} testid="page-body-editor" />
          )}
        </div>

        <button onClick={save} disabled={saving} data-testid="page-save-btn" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#0F2F1D] text-white font-semibold hover:bg-[#1B4D2E] transition-colors disabled:opacity-60">
          <Save className="h-4 w-4" /> {saving ? "Kaydediliyor..." : "Kaydet"}
        </button>
      </div>
    </div>
  );
}
